import { useWsmProductComplianceListQuery } from "@dashboard/graphql";
import useLocalPaginator, { useLocalPaginationState } from "@dashboard/hooks/useLocalPaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React, { useState } from "react";

import WsmComplianceListPage from "../components/WsmComplianceListPage/WsmComplianceListPage";

const PAGINATE_BY = 20;

export const WsmComplianceListView = () => {
  const [query, setQuery] = useState("");
  const [prop65Only, setProp65Only] = useState(false);
  const [rowNumber, setRowNumber] = useState(PAGINATE_BY);
  const [paginationState, setPaginationState] = useLocalPaginationState(rowNumber);
  const paginate = useLocalPaginator(setPaginationState);
  const { data, loading } = useWsmProductComplianceListQuery({
    variables: {
      ...paginationState,
      filter: {
        ...(query ? { search: query } : {}),
        // Off means "every product with a record", not "products without the
        // warning", so the filter is omitted rather than sent as false.
        ...(prop65Only ? { prop65: true } : {}),
      },
    },
  });
  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    data?.wsmProductCompliances?.pageInfo,
    paginationState,
  );

  return (
    <WsmComplianceListPage
      compliances={loading ? undefined : (mapEdgesToItems(data?.wsmProductCompliances) ?? [])}
      query={query}
      prop65Only={prop65Only}
      settings={{ rowNumber }}
      hasNextPage={pageInfo?.hasNextPage ?? false}
      hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
      onQueryChange={value => {
        setQuery(value);
        setPaginationState({});
      }}
      onProp65OnlyChange={value => {
        setProp65Only(value);
        setPaginationState({});
      }}
      onUpdateListSettings={(key, value) => {
        if (key === "rowNumber") {
          setRowNumber(value as number);
        }
      }}
      onNextPage={loadNextPage}
      onPreviousPage={loadPreviousPage}
    />
  );
};

export default WsmComplianceListView;
